import { getSafeImageUrl } from './logo-urls'
import { optimizeRemoteImageForNext } from './optimizeRemoteImageForNext'

const WORKSPACE_LOGO_DISPLAY_WIDTH = 64

export function resolveWorkspaceLogoDisplayUrl(logoUrl: string | null | undefined): string | undefined {
  const safe = getSafeImageUrl(logoUrl ?? undefined)
  return optimizeRemoteImageForNext(safe, WORKSPACE_LOGO_DISPLAY_WIDTH)
}
